/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/assila/"

const assila: CommunityData = {
  code: "assila",
  name: "Assila",
  thumbnail: "",
  favicon: "",
  inviteCode: "assila",
  waitlist: true,
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/asb-422`,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `https://media.werz.at/community-assets/assila/mobile-landing-background.mp4?type=video`,
        mobile: `https://media.werz.at/community-assets/assila/mobile-landing-background.mp4?type=video`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[92px] h-[68px] sm:w-[176px] sm:h-[130px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['HandsonsRoughRegular'] text-[28px] leading-[120%] text-[#ede54b]",
      text: "font-['InterRegular'] text-[16px] leading-[120%] text-[#ede54b]",
      button:
        "font-['HandsonsRoughRegular'] text-[16px] leading-[100%] p-4 bg-[#e84149] text-[#ede54b] cursor-pointer w-fit",
      input: {
        base: "font-['InterRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#ede54b]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['InterRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['InterRegular'] text-[14px] leading-[120%] text-[#6d6d6d]",
      skipButton: "font-['InterRegular'] text-[14px] leading-[120%] text-[#6d6d6d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title:
          "font-['HandsonsRoughRegular'] text-[24px] leading-[120%] text-[#ede54b] text-center",
        text: "font-['InterRegular'] text-[14px] leading-[120%] text-[#6d6d6d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ede54b] bg-[#000000] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      counterColor: "#ede54b",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[176px] h-[130px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[176px] h-[130px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#e84149] px-[18px] py-[18px] text-[#ede54b] font-['HandsonsRoughRegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ede54b",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#ede54b]",
      item: "font-['HandsonsRoundedRegular'] text-[16px] text-[#ede54b] text-center leading-[120%] gap-x-[10px] text-opacity-50 border-b border-[#ede54b] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#ffffff00] !rounded-[24px] !pb-8",
      titles: "text-[#ede54b] font-['HandsonsRoughRegular'] text-[26px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ede54b] font-['InterRegular'] text-[14px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#ede54b] font-['HandsonsRoughRegular'] text-[26px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#e84149]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title:
            "text-[#ede54b] font-['HandsonsRoughRegular'] text-[14px] text-left leading-[110%]",
          subtitle:
            "text-[#ede54b] font-['InterRegular'] text-[14px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0",
        sectionTitle:
          "text-[#ede54b] font-['HandsonsRoughRegular'] text-[26px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#e84149]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title:
            "text-[#ede54b] font-['HandsonsRoughRegular'] text-[14px] text-left leading-[110%]",
          subtitle:
            "text-[#ede54b] font-['InterRegular'] text-[12px] text-left leading-[130%] mt-2",
          location:
            "text-[#ede54b] font-['InterRegular'] text-[12px] text-left leading-[130%] mt-1",
          date: "text-[#ede54b] font-['InterRegular'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ede54b] font-['HandsonsRoughRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ede54b] font-['InterRegular'] text-[16px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ede54b] font-['HandsonsRoughRegular'] text-[26px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border border-[#ffffff00] !rounded-[24px] !pb-8",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#ffffff00]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#ede54b] font-['HandsonsRoughRegular'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#ede54b] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#e84149] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ede54b] font-['HandsonsRoughRegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[130%] text-[#ede54b]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ede54b] font-['HandsonsRoughRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ede54b] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ede54b] font-['HandsonsRoughRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ede54b] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ede54b] font-['HandsonsRoughRegular'] text-[22px] text-left leading-[110%]",
        text: "text-[#ede54b] font-['InterRegular'] text-[14px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#ede54b] font-['HandsonsRoughRegular'] text-[22px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between leading-auto bg-[#e84149] border-b border-[#ede54b] sm:p-4 p-2",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ede54b] font-['HandsonsRoughRegular'] text-[14px] text-left leading-[110%] mb-1",
          description:
            "text-[#ede54b] font-['InterRegular'] text-[14px] text-left leading-[130%] mb-1 flex flex-row",
          price:
            "text-[#ede54b] font-['HandsonsRoughRegular'] text-[14px] text-left leading-[110%]",
          quantity:
            "text-[#ede54b] font-['HandsonsRoughRegular'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#ede54b] font-['HandsonsRoughRegular'] text-[14px] text-left leading-[110%]",
          counterContainer:
            "bg-[#ffffff00] border border-[#ede54b] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#ffffff00] border border-[#ede54b] px-[16px] py-[12px] text-[#ede54b] font-['HandsonsRoughRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ede54b",
        },
      },
    },
  },
}

export default assila
